<template>
  <span class="item">
    <template v-if="storeNames.length !== 0">
      <a class="link" :class="{colorFontBase: !isCompetitor, colorBaseA: isCompetitor}" @click.prevent="openModal()">
        {{ storeNames.length === 1 && isOmitSingleStore ? '' : $t('pages.companies.analysis.table.storesCount', { count: storeNames.length }) }}
      </a>
    </template>
    <template v-else>
      {{ $t('pages.companies.analysis.table.storesCount', { count: storeNames.length }) }}
    </template>
  </span>
</template>
<script>

export default {
  name: 'CompaniesAnalysisStoresCount',
  props: {
    storeNames: {
      type: Array,
      required: true,
    },
    isCompetitor: {
      type: Boolean,
      default: false
    },
    isOmitSingleStore: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open-modal'],
  methods: {
    openModal() {
      this.$emit('open-modal', this.storeNames)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';
.item {
  margin-left: 4px;
}

.link {
  cursor: pointer;
  text-decoration: none;
}

.colorBaseA{
  color: $color-base-a;
}

.colorFontBase {
  color: $color-font-base;
}

</style>
